export * from './api';
export * from './geo';
export * from './print';
export * from './kadastralegemeentecodes';

const bytesInMb = 1048576;

export const DEFAULT_MAP_PADDING = 100;
export const DEFAULT_ANIMATION_MS = 1000;
export const RECORD_INTERACTION_MS = 3000;
export const MAP_POPUP_FADEOUT_MS = 1300;
export const INFOTABLE_HEIGHT_PERC = 25; // % of the height of the viewport
export const INFOTABLE_WIDTH_PERC = 50; // % of the width of the viewport
export const MENUBAR_HEIGHT = 62; // if this value changes, change variables.scss too

export const devices = { sizes: { SMALL: 767 } };

// if 1 of the width values below changes, change variables.scss too
export const PANEL_WIDTHS = {
    DEFAULT: 400,
    INFORMATION: 400,
    MENU: 300,
    FEEDBACK: 550,
    WEB_INFORMATION: 550
};

export const FEEDBACKS_STEPS = {
    CHOOSE_LAYER: 1,
    DRAW: 2,
    EDIT: 3,
    WFST_EDIT: 4,
    DELETE: 5
};

export const USER_MAPS_MODUS = {
    ADD: 1,
    EDIT: 2,
    DELETE: 3
};

export const IMPORT_LAYER_MODUS = {
    ADD: 1,
    EDIT: 2,
    DELETE: 3
};

export const IMPORT_TARGET = {
    LAYER: 1,
    FEEDBACK: 2
};

export const IMPORT_FILE_TYPES = [
    {
        name: 'shape',
        extensions: [
            'zip'
        ],
        maxSize: 5 * bytesInMb
    },
    {
        name: 'gml',
        extensions: [
            'gml', 'xml'
        ],
        maxSize: 20 * bytesInMb
    },
    {
        name: 'geojson',
        extensions: [
            'json', 'geojson'
        ],
        maxSize: 20 * bytesInMb
    },
    {
        name: 'csv',
        extensions: [
            'csv'
        ],
        maxSize: 20 * bytesInMb
    }
];

export const FEEDBACKS_GEOMETRY_TYPE_CODES = {
    POINT: 'P',
    LINE: 'L',
    POLYGON: 'V'
};

export const FEEDBACKS_GEOMETRY_TYPES = {
    POINT: 'Point',
    LINE: 'LineString',
    POLYGON: 'Polygon'
};

export const SORT_WEBTHEME = {
    // Ref Code Key
    'KEY': 'SORT_WEBTHEME',
    // Ref Code  Values
    'TITLE': 'T',
    'POPULARITY': 'P'
};

// Portal startup modes
export const PORTAL_MODE = {
    'PORTAL': 'P',
    'DEMO': 'D',
    'TOPPAGE': 'T'
};

// types of (origin of) selections for the resultatentabel
export const SELECTION_TYPES = {
    FILTERED: 'filtered',
    LAYERS: 'layers',
    SELECTION: 'selection',
    SEARCH: 'search',
    CLUSTER: 'cluster',
    RELATION: 'relation'
};

// the mode of selecting to store in the state for the selection dropdown
export const SELECTION_MODES = { BUFFER: 'buffer' };

// the mode of selecting to store in the state for the selection dropdown
export const SELECTION_TOOLS = {
    POINT: 'point',
    CIRCLE: 'circle',
    POLYGON: 'polygon'
};

// local storage keys
export const LOCAL_STORAGE_KEYS = {
    LAYERS: 'LAYERS',
    VIEWPORT: 'VIEWPORT',
    UIELEMENTS: 'UIELEMENTS'
};

export const INTERFACE_PANEL_TRIGGERS = {
    SELECTION: 'menuSelection',
    ADVANCED_SEARCH: 'advancedSearch',
    MENU: 'menu',
    PRINT: 'print',
    LEGEND: 'legend',
    FILTERS: 'filters',
    USERMAPS: 'userMaps',
    INFORMATION: 'resultTable',
    BRK: 'brk',
    OBJECT_DETAILS: 'objectDetails',
    SEARCH_RESULTS: 'searchresults',
    FEEDBACK_EDIT: 'feedbackEdit',
    MEASURE_EDIT: 'measureEdit',
    CLOSE_FEEDBACK: 'closeFeedback',
    WEB_FEEDBACK: 'webFeedback',
    WEB_INFORMATION: 'webInformation',
    BASELAYER: 'baselayer',
    ADDRESSES: 'adresses',
    ENERGYLABEL: 'energylabel',
    MESSAGESFEED: 'messagesFeed',
    DATAEXPORT: 'dataExport',
    SEARCH_SETTINGS: 'searchSettings',
    QUICKACCESS: 'quickAccess',
    WFS_T_EDIT: 'WfsTEdit',
    CLOSE_WFS_T: 'closeWfsT',
    WELCOME_PANEL: 'showWelcomeMessage'
};

// Mock data, remove later on
export const BRK_MOCK_IDS = {
    PARCEL_WITH_APARTMENT: '76870482570000', // Atalanta 21 Beekbergen
    APARTMENT: '7687045387', // ?
    APARTMENT_INFO: '76870487970000' // Atalanta 29 Beekbergen
};

// Advanced styling options
export const CUSTOM_STYLING_RULE_OTHER = 'other';

// Theme layers
export const THEMELAYER_PARCELS_BRK = 'Percelen (BRK)';

// Themes
export const THEME_NEDBRK = 'NedBRK';

// Theme groups
export const THEME_GROUP_OTHER = 'OTHER';

export const SUPPORTED_IMPORT_GEOMETRY_TYPES = ['Point', 'LineString', 'Polygon'];

// Tab index of advanced style
export const ADVANCED_STYLE_TAB_INDEX = {
    'TAB_CLUSTER': 0,
    'TAB_ADVANCED': 1
};

// Tab status
export const TAB_STATUS = {
    'LOADING': 'loading',
    'READY': 'ready',
    'ERROR': ' error'
};

// Tab types
export const TAB_TYPES = {
    POINTER: 0,
    LAYER: 1,
    ADMIN: 2
};

export const ONLINE_HELP = {
    COMMON: { uri: 'https://www.cadac.com/service-support/support/nedglobe/handleidingen/' },
    MOBILE: {
        helpfile: 'gebruikershandleiding-nedglobe-mobile',
        title: 'NedGlobe Mobile help'
    },
    DASHBOARD: {
        helpfile: 'gebruikershandleiding-nedglobe-dashboard',
        title: 'NedGlobe Dashboard help'
    }
};

export const SORT_ORDER = {
    ASCENDING: 'ASC',
    DESCENDING: 'DESC'
};

export const DATAIMPORT_STATUS = {
    NEW: 'NEW',
    ERROR: 'ERROR',
    UPLOAD_FME: 'UPLOAD_FME',
    ANALYSE_FME: 'ANALYSE_FME',
    START_LOAD_FME: 'START_LOAD_FME',
    LOADED_FME: 'LOADED_FME'
};

export const DATAIMPORT_FORMAT = {
    SHAPE: 'shape',
    GEOPACKAGE: 'geopackage',
    CSV: 'csv',
    DXF: 'dxf'
};

export const NEWSITEMS_TYPES = {
    NEWSITEMS: 'newsitems',
    MSGFEEDS: 'msgfeeds'
};

export const DATAEXPORT_STATUS = {
    NEW: 'NEW',
    ERROR: 'ERROR',
    START_EXPORT_FME: 'START_EXPORT_FME',
    EXPORTED_FME: 'EXPORTED_FME'
};

export const CHART_TYPES = {
    COLUMN_CHART: 'ColumnChart',
    PIE_CHART: 'PieChart',
    BAR_CHART: 'BarChart'
};

export const VUE_EDITOR_TYPES = {
    WELCOME_PANEL: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        [{ list: 'ordered' }],
        [{ color: [] }, { background: [] }],
        ['link'],
        ['clean'] // remove formatting button
    ]
};

export const WOZ_FIELDS = [
    'identificatie',
    'aanduiding',
    'waarden',
    'grondoppervlakte',
    'adresseerbaarObjectIdentificaties'
];
